module.exports = __webpack_public_path__ + "static/media/03-_law-court-hammer-judge.df3c2fbd.png";